import { GetStaticProps, NextPage } from 'next';

import { api, makeDehydratedQueries } from '@endaoment-frontend/api';

import { MediaCarousel } from '../content/mediaCarousel';
import { MetaTags } from '../content/metaTags';
import { OTCHero, OTCSearch } from '../content/otc';
import { SocialLinks } from '../content/socialLinks';

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      dehydratedState: await makeDehydratedQueries([api.GetOTCAddresses.key, api.GetOTCAddresses.query]),
    },
    // ISR every 10 minutes
    revalidate: 6000,
  };
};

const OTCPage: NextPage = () => {
  return (
    <>
      <MetaTags url="/otc" title="Endaoment | OTC" />

      <OTCHero />
      <OTCSearch />

      <MediaCarousel />
      <SocialLinks />
    </>
  );
};

export default OTCPage;
